import { r as registerInstance, c as createEvent, h, H as Host } from './index-662ec80e.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { a1 as vUndefOr, a as vString, W as vArrayOf, Z as vObjectWith, Q as vBoolean, U as vArrayMinLength, J as vNumber, S as vOneOf, Y as vObject } from './validation-02b8d01d.js';
import { t as tuple } from './types-6f6b2fba.js';
import './i18n-939e2dee.js';

const tableSortDirections = tuple('ASC', 'DESC');

const dsTableCss = "ds-table{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}ds-table .table-header{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}ds-table .table-header .actions-container{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}ds-table .table-header [slot=\"filters\"]{width:100%;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}ds-table .table-header [slot=\"filters\"] ds-input-string,ds-table .table-header [slot=\"filters\"] ds-input-bignumber,ds-table .table-header [slot=\"filters\"] ds-input-date,ds-table .table-header [slot=\"filters\"] ds-input-datetime,ds-table .table-header [slot=\"filters\"] ds-input-date-range,ds-table .table-header [slot=\"filters\"] ds-input-date-picker,ds-table .table-header [slot=\"filters\"] ds-input-number,ds-table .table-header [slot=\"filters\"] ds-radio-toggle,ds-table .table-header [slot=\"filters\"] ds-select,ds-table .table-header [slot=\"filters\"] ds-select-simple,ds-table .table-header [slot=\"filters\"] ds-select-multiple{-ms-flex:1;flex:1;min-width:10rem;max-width:14rem}ds-table .table-header [slot=\"filters\"] ds-input-string .help-info,ds-table .table-header [slot=\"filters\"] ds-input-bignumber .help-info,ds-table .table-header [slot=\"filters\"] ds-input-date .help-info,ds-table .table-header [slot=\"filters\"] ds-input-datetime .help-info,ds-table .table-header [slot=\"filters\"] ds-input-date-range .help-info,ds-table .table-header [slot=\"filters\"] ds-input-date-picker .help-info,ds-table .table-header [slot=\"filters\"] ds-input-number .help-info,ds-table .table-header [slot=\"filters\"] ds-radio-toggle .help-info,ds-table .table-header [slot=\"filters\"] ds-select .help-info,ds-table .table-header [slot=\"filters\"] ds-select-simple .help-info,ds-table .table-header [slot=\"filters\"] ds-select-multiple .help-info,ds-table .table-header [slot=\"filters\"] ds-input-string .help-error,ds-table .table-header [slot=\"filters\"] ds-input-bignumber .help-error,ds-table .table-header [slot=\"filters\"] ds-input-date .help-error,ds-table .table-header [slot=\"filters\"] ds-input-datetime .help-error,ds-table .table-header [slot=\"filters\"] ds-input-date-range .help-error,ds-table .table-header [slot=\"filters\"] ds-input-date-picker .help-error,ds-table .table-header [slot=\"filters\"] ds-input-number .help-error,ds-table .table-header [slot=\"filters\"] ds-radio-toggle .help-error,ds-table .table-header [slot=\"filters\"] ds-select .help-error,ds-table .table-header [slot=\"filters\"] ds-select-simple .help-error,ds-table .table-header [slot=\"filters\"] ds-select-multiple .help-error{display:none}ds-table>.table-container{-ms-flex:1;flex:1;overflow-x:auto;overflow-y:auto;position:relative;border-radius:var(--radius);scrollbar-width:thin;margin-top:1rem}ds-table>.table-container>ds-loader{position:absolute;z-index:1000;left:calc(50% - 1rem);top:7rem}ds-table>.table-container>table{width:100%;padding:0;border:0;vertical-align:baseline;text-align:left;background-color:var(--white);border-collapse:separate !important;border-radius:var(--radius);position:relative;font-size:0.79012346rem;line-height:1.3rem}ds-table>.table-container>table tr:nth-child(even){background-color:var(--grey-100)}ds-table>.table-container>table>thead tr{position:sticky;top:0;z-index:2}ds-table>.table-container>table>thead td{vertical-align:middle;text-align:left;padding:calc(var(--gw) * 0.5) calc(var(--gw) * 0.9) calc(var(--gw) * 0.5) calc(var(--gw) * 0.9);text-transform:capitalize;color:var(--coolGrey-600);background:var(--grey-300);font-size:0.88888889rem;line-height:1.56rem;font-weight:500}ds-table>.table-container>table>thead td:last-of-type{border-right:none}ds-table>.table-container>table>thead td>div>span{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}ds-table>.table-container>table>thead td>div>span>ds-tooltip{padding-top:0.3rem}ds-table>.table-container>table>thead td.sortable{cursor:pointer}ds-table>.table-container>table>thead td.sortable:hover{color:var(--coolGrey-800);background-color:var(--grey-100)}ds-table>.table-container>table>thead td.sortable>div{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between}ds-table>.table-container>table>thead td.sortable>div>div{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap;margin-top:0.35rem;margin-left:calc(var(--gw) * 0.5)}ds-table>.table-container>table>thead td.sorted{color:var(--coolGrey-800);background-color:var(--grey-100)}ds-table>.table-container>table>thead td.selectable{vertical-align:middle}ds-table>.table-container>table>thead td.selectable>div>span{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}ds-table>.table-container>table>thead td.selectable>div>span ds-input-checkbox{display:-ms-flexbox;display:flex}ds-table>.table-container>table>thead td.selectable>div>span ds-tooltip{position:relative;top:0px}ds-table>.table-container>table>thead td ds-icon[name=info] svg{overflow:visible}ds-table>.table-container>table>thead td ds-tooltip{white-space:nowrap;margin-left:calc(var(--gw) * 0.5);text-transform:none;position:relative;top:1px}ds-table>.table-container>table>thead td ds-tooltip:hover svg{color:var(--info);fill:var(--info)}ds-table>.table-container>table tbody tr:hover td{background-color:var(--blue-100)}ds-table>.table-container>table tbody tr.selected td{background-color:var(--blue-200) !important}ds-table>.table-container>table tbody tr td{vertical-align:middle;text-overflow:ellipsis;white-space:nowrap;padding:calc(var(--gw) * 0.5) calc(var(--gw) * 0.9) calc(var(--gw) * 0.5) calc(var(--gw) * 0.9);color:var(--black)}ds-table[is-loading]>.table-container>table tbody,ds-table[is-loading]>.table-container>table thead{opacity:0.6}ds-table[is-loading]>.table-container>table tbody{pointer-events:none}";

const DsTable = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.setColumns = createEvent(this, "setColumns", 7);
    this.setSelectedRows = createEvent(this, "setSelectedRows", 7);
    this.loadData = createEvent(this, "loadData", 7);
    this.propError = {};
    this.height = undefined;
    this.width = undefined;
    this.header = undefined;
    this.isSortable = false;
    this.totalRows = undefined;
    this.currentPage = undefined;
    this.rowsPerPage = undefined;
    this.isLoading = false;
    this.sortBy = undefined;
    this.sortDirection = 'ASC';
    this.filter = {};
    this.debounce = 100;
    this.allSelected = false;
    this.selectedRows = undefined;
    this.selectableRows = undefined;
  }
  watchHeight() {
    /* istanbul ignore if */
    if (!propCheck(this, 'height', 'string', vUndefOr(vString)))
      return;
  }
  watchWidth() {
    /* istanbul ignore if */
    if (!propCheck(this, 'width', 'string', vUndefOr(vString)))
      return;
  }
  watchHeader() {
    /* istanbul ignore if */
    if (!propCheck(this, 'header', 'Array<{ key: string, label?: string, isSortable?: boolean, isSelectable?: boolean, info?: string }>', v => vArrayOf(vObjectWith({
      key: vString,
      label: vUndefOr(vString),
      isSortable: vUndefOr(vBoolean),
      isSelectable: vUndefOr(vBoolean),
      info: vUndefOr(vString),
    }))(v) ||
      vArrayMinLength(1)(v)))
      return;
  }
  watchIsSortable() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isSortable', 'boolean', vBoolean))
      return;
  }
  watchTotalRows() {
    /* istanbul ignore if */
    if (!propCheck(this, 'totalRows', 'number', vUndefOr(vNumber)))
      return;
  }
  watchCurrentPage() {
    if (this.totalRows) {
      /* istanbul ignore if */
      if (!propCheck(this, 'currentPage', 'number (with totalRows)', vNumber))
        return;
    }
    else {
      /* istanbul ignore if */
      if (!propCheck(this, 'currentPage', 'number? (without totalRows)', vUndefOr(vNumber)))
        return;
    }
  }
  watchRowsPerPage() {
    if (this.totalRows) {
      /* istanbul ignore if */
      if (!propCheck(this, 'rowsPerPage', 'number (with totalRows)', vNumber))
        return;
    }
    else {
      /* istanbul ignore if */
      if (!propCheck(this, 'rowsPerPage', 'number? (without totalRows)', vUndefOr(vNumber)))
        return;
    }
  }
  watchIsLoading() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isLoading', 'boolean', vBoolean))
      return;
  }
  watchSortBy() {
    const headerKeys = this.header ? this.header.map(header => header.key) : [];
    if (this.isSortable) {
      /* istanbul ignore if */
      if (!propCheck(this, 'sortBy', headerKeys.join(' | ') + ' (with isSortable)', vOneOf(headerKeys)))
        return;
    }
    else {
      /* istanbul ignore if */
      if (!propCheck(this, 'sortBy', 'string? (without isSortable)', vUndefOr(vString)))
        return;
    }
  }
  watchSortDirection() {
    if (this.isSortable) {
      /* istanbul ignore if */
      if (!propCheck(this, 'sortDirection', tableSortDirections.join(' | ') + ' (with isSortable)', vOneOf(tableSortDirections)))
        return;
    }
    else {
      /* istanbul ignore if */
      if (!propCheck(this, 'sortBy', 'string? (without isSortable)', vUndefOr(vString)))
        return;
    }
  }
  watchFilter() {
    /* istanbul ignore if */
    if (!propCheck(this, 'filter', '{ [key:string]: any }', vObject))
      return;
  }
  watchDebounce() {
    /* istanbul ignore if */
    if (!propCheck(this, 'debounce', 'number', vNumber))
      return;
  }
  watchSelectedRows() {
    /* istanbul ignore if */
    if (!propCheck(this, 'selectedRows', 'Array<number | string> | undefined', vUndefOr(vArrayOf(v => vString(v) && vNumber(v)))))
      return;
    if (Array.isArray(this.selectableRows) && Array.isArray(this.selectedRows)) {
      this.allSelected = this.selectableRows.every(r => this.selectedRows.includes(r));
    }
  }
  watchSelectableRows() {
    /* istanbul ignore if */
    if (!propCheck(this, 'selectableRows', 'Array<number | string>', vUndefOr(vArrayOf(v => vString(v) && vNumber(v)))))
      return;
    if (Array.isArray(this.selectableRows) && Array.isArray(this.selectedRows)) {
      this.allSelected = this.selectableRows.every(r => this.selectedRows.includes(r));
    }
  }
  emitLoadData(detail, immediate = false) {
    clearTimeout(this.loadDataDebounce);
    const filter = Object.assign(Object.assign({}, this.filter), detail.filter);
    for (let key of Object.keys(filter)) {
      if (!filter[key])
        delete filter[key];
    }
    const nextState = Object.assign(Object.assign({ sortBy: this.sortBy, sortDirection: this.sortDirection, rowsPerPage: this.rowsPerPage, currentPage: this.currentPage }, detail), { filter });
    if (!this.isSortable) {
      delete nextState.sortBy;
      delete nextState.sortDirection;
    }
    if (this.totalRows === undefined) {
      delete nextState.rowsPerPage;
      delete nextState.currentPage;
    }
    this.loadDataDebounce = setTimeout(() => {
      this.loadData.emit(nextState);
    }, immediate ? 1 : this.debounce);
  }
  isElementImmediateChild(element) {
    let elementRef = element.parentElement;
    if (elementRef.matches('[slot=filters]'))
      return true;
    do {
      if (elementRef.tagName.startsWith("DS-"))
        return false;
      elementRef = elementRef.parentElement;
    } while (!elementRef.matches('[slot=filters]'));
    return true;
  }
  // This is effectively the "filter" event AND select/unselect
  onDsInput(e) {
    const target = e.target;
    if (target.closest('[slot=filters]')) {
      // filter event
      if (!this.isElementImmediateChild(target))
        return;
      const el = target;
      const detail = e.detail;
      el.value = detail;
      if (el.validate && el.validate(el.value))
        return;
      const filter = Object.assign({}, this.filter);
      if (detail === '')
        filter[el.name] = undefined;
      else
        filter[el.name] = detail;
      this.emitLoadData({ filter, currentPage: 1 });
      this.setSelectedRows.emit([]);
    }
    else /* istanbul ignore else */ if (target.closest('thead')) {
      // selectable event
      e.preventDefault();
      e.stopPropagation();
      const el = target;
      const allSelected = e.detail;
      const newSelectedRows = [...this.selectedRows];
      const checkboxes = Array.from(el.closest('ds-table').querySelectorAll('tbody tr td:first-child ds-input-checkbox'));
      for (let checkbox of checkboxes) {
        if (allSelected) {
          /* istanbul ignore else */
          if (newSelectedRows.findIndex((r) => r === checkbox.checkedValue) === -1) {
            newSelectedRows.push(checkbox.checkedValue);
          }
        }
        else {
          const index = newSelectedRows.findIndex(id => id === checkbox.checkedValue);
          /* istanbul ignore else */
          if (index !== -1) {
            newSelectedRows.splice(index, 1);
          }
        }
      }
      this.setSelectedRows.emit(newSelectedRows);
    }
  }
  // sort event
  setOrder(header) {
    if (header.key === this.sortBy) {
      this.emitLoadData({ sortDirection: this.sortDirection === 'ASC' ? 'DESC' : 'ASC', currentPage: 1 }, true);
    }
    else {
      this.emitLoadData({ sortDirection: 'ASC', sortBy: header.key, currentPage: 1 }, true);
    }
    this.setSelectedRows.emit([]);
  }
  // page event
  setPage({ currentPage, rowsPerPage }) {
    this.emitLoadData({ currentPage, rowsPerPage: rowsPerPage }, true);
    this.tableContainer.querySelector('thead tr td:first-child').scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
    this.setSelectedRows.emit([]);
  }
  connectedCallback() {
    runWatchers(this);
    // initial set or reset of headers to render
    if (Array.isArray(this.header))
      this.setColumns.emit(this.header.map(h => h.key));
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    return (h(Host, { style: { width: this.width } }, h("div", { class: "table-header" }, h("div", { class: "actions-container" }, h("slot", { name: "actions" })), h("slot", { name: "filters" })), h("div", { ref: el => this.tableContainer = el, class: "table-container", style: { height: this.height } }, this.isLoading && h("ds-loader", { size: "2rem", version: "dots", color: "var(--primary)" }), h("table", null, h("thead", null, h("tr", null, this.header.map((header) => {
      const selectable = header.isSelectable === true;
      const sortable = this.isSortable !== false && header.isSortable !== false && !selectable;
      const sorted = sortable && this.sortBy === header.key;
      return (h("td", { class: { sortable, sorted, selectable }, onClick: () => sortable && this.setOrder(header) }, h("div", null, h("span", null, header.isSelectable
        ? h("ds-input-checkbox", { label: header.label, name: 'ds-table-select-all', value: this.allSelected })
        : h("span", null, header.label), header.info && h("ds-tooltip", { text: header.info }, h("ds-icon", { name: "info", color: "var(--coolGrey-400)", size: "0.8rem" }))), sortable && h("div", null, h("ds-icon", { name: "triangle-up", color: sorted && this.sortDirection === 'ASC'
          ? 'var(--black)'
          : 'var(--grey-700)', size: "6.5px" }), h("ds-icon", { name: "triangle-down", color: sorted && this.sortDirection === 'DESC'
          ? 'var(--black)'
          : 'var(--grey-700)', size: "6.5px" })))));
    }))), h("slot", null))), this.totalRows
      ? h("ds-pagination", {
        // pagination={this.pagination}
        totalRows: this.totalRows, currentPage: this.currentPage, rowsPerPage: this.rowsPerPage, onPage: ({ detail }) => this.setPage(detail)
      })
      : ''));
  }
  static get watchers() { return {
    "height": ["watchHeight"],
    "width": ["watchWidth"],
    "header": ["watchHeader"],
    "isSortable": ["watchIsSortable"],
    "totalRows": ["watchTotalRows"],
    "currentPage": ["watchCurrentPage"],
    "rowsPerPage": ["watchRowsPerPage"],
    "isLoading": ["watchIsLoading"],
    "sortBy": ["watchSortBy"],
    "sortDirection": ["watchSortDirection"],
    "filter": ["watchFilter"],
    "debounce": ["watchDebounce"],
    "selectedRows": ["watchSelectedRows"],
    "selectableRows": ["watchSelectableRows"]
  }; }
};
DsTable.style = dsTableCss;

export { DsTable as ds_table };
